
import { defineComponent, ref, reactive, onMounted, watch } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Top, Bottom, Delete } from "@element-plus/icons-vue";
import type { ElForm } from "element-plus";

type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  setup() {
    onMounted(() => {
      if (!route.params.id) {
        setCurrentPageBreadcrumbs("目录新增", ["目录管理;box_categories"])
      } else {
        setCurrentPageBreadcrumbs("目录编辑", ["目录管理;box_categories", route.params.id.toString()])
      }
    });

    const rules = ref({
      // name: [
      //   {
      //     required: true,
      //     message: "商圈名称不可为空",
      //     trigger: "change",
      //   },
      // ],
    });

    const formRef = ref<FormInstance>();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const box_category = ref({} as any)

    let ruleUidCounter = 0;
    const makeRule = (field: string, direction: string) => ({
      field,
      direction,
      _uid: ++ruleUidCounter,
    });

    const getDefaultSortRules = () => {
      const type = box_category.value.category_type;
      // normal(0) → price ASC + created_at DESC; wide(1)/match(2) → created_at DESC only
      if (type === 0 || type === undefined || type === null) {
        return [makeRule("price", "asc"), makeRule("created_at", "desc")];
      }
      return [makeRule("created_at", "desc")];
    };
    const sortRules = ref<Array<{ field: string; direction: string; _uid: number }>>(
      [makeRule("price", "asc"), makeRule("created_at", "desc")]
    );

    const addSortRule = () => {
      if (sortRules.value.length < 5) {
        sortRules.value.push(makeRule("created_at", "desc"));
      }
    };

    const removeSortRule = (index: number) => {
      sortRules.value.splice(index, 1);
    };

    const moveSortRule = (index: number, delta: number) => {
      const target = index + delta;
      if (target < 0 || target >= sortRules.value.length) return;
      const temp = sortRules.value[index];
      sortRules.value[index] = sortRules.value[target];
      sortRules.value[target] = temp;
      sortRules.value = [...sortRules.value]; // trigger reactivity
    };

    const onCancel = () => {
      router.push({ name: "box_categories" });
    };

    const isNew = !route.params.id;

    const syncSortRules = () => {
      box_category.value.sort_rules = sortRules.value.length > 0
        ? sortRules.value.map(r => ({ field: r.field, direction: r.direction }))
        : null;
    };

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return;

      formEl.validate((valid) => {
        if (valid) {
          syncSortRules();
          if (isNew) {
            store
              .dispatch(
                Actions.CREATE_BOX_CATEGORY,
                box_category.value
              )
              .then(() => {
                router.push({ name: "box_categories" });
              })
              .catch(() => {
                // const [error] = Object.keys(store.getters.getErrors);
                // Swal.fire({
                //   text: store.getters.getErrors[error],
                //   icon: "error",
                //   buttonsStyling: false,
                //   confirmButtonText: "Try again!",
                //   customClass: {
                //     confirmButton: "btn fw-bold btn-light-danger",
                //   },
                // });
              });
          } else {
            store
              .dispatch(Actions.UPDATE_BOX_CATEGORY, {
                id: route.params.id,
                values: box_category.value,
              })
              .then(() => {
                router.push({ name: "box_categories" });
              })
              .catch(() => {
                // const [error] = Object.keys(store.getters.getErrors);
                // Swal.fire({
                //   text: store.getters.getErrors[error],
                //   icon: "error",
                //   buttonsStyling: false,
                //   confirmButtonText: "Try again!",
                //   customClass: {
                //     confirmButton: "btn fw-bold btn-light-danger",
                //   },
                // });
              });
          }
        } else {
          return false;
        }
      });
    };

    if (!isNew) {
      store
        .dispatch(Actions.GET_BOX_CATEGORY, route.params.id)
        .then(() => {
          box_category.value = store.getters.currentBoxCategory

          imageUrl.value = box_category.value.image_url.startsWith("http")
            ? box_category.value.image_url
            : ""

          // Load sort_rules or fallback to category-type-aware defaults
          if (box_category.value.sort_rules && box_category.value.sort_rules.length > 0) {
            sortRules.value = box_category.value.sort_rules.map((r: any) =>
              makeRule(r.field, r.direction)
            );
          } else {
            sortRules.value = getDefaultSortRules();
          }
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    }

    const imageUrl = ref("")

    const onChange = (file) => {
      var reader = new FileReader();
      reader.readAsDataURL(file.raw)
      reader.onload = (e) => {
        imageUrl.value = e.target?.result?.toString() || ""
        box_category.value.image = imageUrl.value
      }
    }

    return {
      onSubmit,
      box_category,
      rules,
      onCancel,
      formRef,
      onChange,
      imageUrl,
      sortRules,
      addSortRule,
      removeSortRule,
      moveSortRule,
      Top,
      Bottom,
      Delete,
    };
  },
});
